export default __webpack_public_path__ + "img/c6a1073875e6bd5e0711687156b2df2d.svg";